import { Outlet } from 'react-router-dom';

import { PageLayoutContainer } from './style';

export const PageLayout = () => (
  <PageLayoutContainer>
    <Outlet />
  </PageLayoutContainer>
);
